export const PATTERNS = {
	DATE: /^\d{4}-\d{2}-\d{2}$/,
	PHONE: /^\+?[1-9]\d{1,14}$/,
	PHONE_STRICT: /^\+?[1-9]\d{9,14}$/,
	POSTAL_CODE: /^[0-9A-Za-z\-\s]{3,10}$/,
	NAME: /^[^0-9]+$/,
	PERSON_NAME: /^[\p{L}\s-]+$/u,
	ADDRESS_LINE: /^[^,]+$/,
	EMAIL_NO_UMLAUTS: /^[^äÄöÖüÜß]+$/,
	UUID: /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i,
};
